<template>
  <div>
    <!--Need cleanout-->
    <v-card-title>
      Your articles
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      dark
      :headers="ArticlesHeaders"
      :items="filteredArticles"
      item-key="id"
      :expanded.sync="expanded"
      :single-expand="openOnlyOne"
      :search="search"
      @click:row="expandRow"
      :items-per-page="5"
      :footer-props="{
        showFirstLastPage: false,
        showCurrentPage: true,
        firstIcon: 'fas fa-arrow-circle-left',
        lastIcon: 'fas fa-arrow-circle-right',
        prevIcon: 'fas fa-arrow-left',
        nextIcon: 'fas fa-arrow-right',
        itemsPerPageText: '',
        itemsPerPageOptions: [5, 10, 15, -1],
        disablePagination: false,
        disableItemsPerPage: false,
        itemsPerPageAllText: 'See all'
      }"
    >
      <!-- FOOTER PROPS (14)
          1. nextIcon: 'fas fa-arrow-right',        #Define the icon that will be the 'go one page forward' on the table page
          2. prevIcon: 'fas fa-arrow-left',          #Define the icon that will be the 'go one page back' on the table page
          3. lastIcon: 'fas fa-arrow-circle-right',  #Define an icon that will be the 'quick travel' to the last table page
          4. firstIcon: 'fas fa-arrow-circle-left',  #Define an icon that will be the 'quick travel' to the first table page
          5. showFirstLastPage: false,               #Will display 2 extra arrows, where one can 'quick travel' to the first page or the last one
                                                      - Used with the firstIcon and lastIcon property
          6. disablePagination: false                #Disable the pagination option of the arrows if set as true
          7 .disableItemsPerPage: false              #Disable the pagination dropdown, it is still there. just greyed out
          8. showCurrentPage: false,                 #Will between the icons of prevIcon and nextIcon display the table page number one are at.    <- 2 ->
          9. itemsPerPageAllText: 'See all'          #Define what the "see all" text should be in the pagination dropdown.   replace the words ALL at the bottom
          10. pageText: ''                           #Will replace the numbers that tells how many entries the current data table are displaying.   1-5 of 15 for example.
                                                      - It can be good if wanting to either remove it, making it more clean, or add custom text.
          11. itemsPerPageText: '',                  #Edit the text before the pagination dropdown, replace the text Rows per page with what you wish.
                                                      - Tip: make it '' then the field will be blank, and give a more clean look
          12. itemsPerPageOptions:[3,4,7, -1]        #This define the pagination Dropdown menu.  It contain 3 core values within the array.
                                                      - The first number define how many will be displayed on each page.  (It do need the data-table to have the prop :items-per-page="5" to be in place, to have an default value).
                                                      - The second, and third number define the option to see that amount of entries on the table page.  It can have more numbers, example:  itemsPerPageOptions: [5, 10, 15, 17, 20 -1],
                                                      - The last number,  -1  define that one should be able to see ALL the posts.   Not sure why it is -1 but it define as much.
                                                      - Tip: If wanting to remove this pagination, just leave the array empty, or add the first number to it, defining the amount of entries to be displayed
          13. pagination:{}                          #Need to be tested, didnt get it to work
          14. Options:{}                             #Need to be tested, didnt get it to work
      -->
      <!-- DATA TABLE PROPS

      -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div v-for="content in item.Content" :key="content.id">
            <v-row style="background-color:pink; color:black;">
              <v-col md="12">
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn @click="editArticle(item.id)" class="mr-3">
                    {{ $t("Edit article") }}
                    <v-icon class="ml-2">edit</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
              <v-col md="12">
                <p class="text-center headline font-weight-bold">{{ content.Title }}</p>
              </v-col>
              <v-col md="12">
                <p class="headline font-weight-bold ma-0 pa-0">Article</p>
                <p class="subtitle-1">{{ content.Content }}</p>
              </v-col>
              <v-col md="12" class="ma-0 pa-0 pl-5">
                <span class="subtitle-1 font-weight-bold">ID :</span>
                <span class="subtitle-2">{{ item.id }}</span>
              </v-col>
              <v-col md="12" class="ma-0 pa-0 pl-5">
                <span class="subtitle-1 font-weight-bold">Date created :</span>
                <span class="subtitle-2">{{ item.Created | moment("LLL") }}</span>
              </v-col>
              <v-col md="12" class="ma-0 pa-0 pl-5 pb-5">
                <span class="subtitle-1 font-weight-bold">Language :</span>
                <span class="subtitle-2 font-weight-bold">{{ content.Lang }}</span>
              </v-col>
              <!--Is published?-->
              <v-col md="12" class="ma-0 pa-0 pl-5" v-if="item.Published == 1">
                <span class="subtitle-1 font-weight-bold">It is publiched</span>
                <span class="subtitle-2 font-weight-bold">
                  <input type="checkbox" class="my-1" disabled :checked="item.Published == 1" />
                </span>
              </v-col>
              <v-col md="12" class="ma-0 pa-0 pl-5" v-else>
                <span class="subtitle-1 font-weight-bold">It is not published</span>
                <span class="subtitle-2 font-weight-bold">
                  <input type="checkbox" class="my-1" disabled :checked="item.Published == 1" />
                </span>
              </v-col>
              <!--Comments on or off?-->
              <v-col md="12" class="ma-0 pa-0 pl-5 pb-5" v-if="item.Comments == 1">
                <span class="subtitle-1 font-weight-bold">Comments are disabled</span>
                <span class="subtitle-2 font-weight-bold">
                  <input type="checkbox" class="my-1" disabled :checked="item.Comments == 1" />
                </span>
              </v-col>
              <v-col md="12" class="ma-0 pa-0 pl-5 pb-5" v-else>
                <span class="subtitle-1 font-weight-bold">Comments are enabled</span>
                <span class="subtitle-2 font-weight-bold">
                  <input type="checkbox" class="my-1" disabled :checked="item.Comments == 1" />
                </span>
              </v-col>
            </v-row>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import messages from "../../modules/lang/articles-list/export";

export default {
  i18n: { messages },
  data() {
    return {
      expanded: [],
      search: "",
      openOnlyOne: true,
      ArticlesHeaders: [
        // { text: "#", value: "id", sortable: false },
        { text: "", value: "", sortable: false },
        { text: this.$t("Created"), value: "Created", sortable: true },
        // { text: this.$t("Title"), value: "Content[0].Title", sortable: false },
        { text: this.$t("Title"), value: "Title", sortable: false },
        { text: this.$t("Category"), value: "Category", sortable: false },
        { text: "", value: "data-table-expand", sortable: false }, // to move the expand icon to the end
        // { text: '', value: 'expand', align:'end' }
      ],
      Articles: [],
      ArticleTypes: [],
      SelectedArticleType: null,
      Content: [],
    };
  },
  computed: {
    filteredArticles() {
      let _articleType = this.SelectedArticleType || this.ArticleTypes[0];
      if (_articleType != this.SelectedArticleType)
        this.SelectedArticleType = _articleType;
      // Here is the variable to get title out of content array, by mapping it
      let _Articles = this.Articles.map((article) => {
        // archive.title shall now be displayed in the original language written
        article.Title = article.Content.find(
          (el) => el.Lang == article.OrgLanguage
        );
        // Here created get moment added into itself
        article.Created = this.$moment(article.Created).format("lll");
        // If not finding any title this way, then go to the first element that match the key title
        if (!article.Title) article.Title = article.Content[0].Title;
        // Else, make title key into the primary array
        else {
          article.Title = article.Title.Title;
        }
        return article;
      });
      if (!_articleType) {
        return this.Articles;
      }
      return this.Articles.filter(
        (article) => article.ArticleType == _articleType
      );
    },
  },

  methods: {
    // Edit the article, by going to the article id
    editArticle(articleId) {
      this.HISTORY_SET({ name: "listarticles" });
      this.$router.push({
        name: "editarticle",
        params: { articleid: articleId },
      });
    },
    // Expand on tr INSTEAD of the show-expand that are default on opening an row
    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item];
    },
    ...mapMutations(["HISTORY_SET", "HISTORY_REMOVE"]),
    ...mapActions(["GET_ARTICLES"]),
  },
  mounted() {
    this.GET_ARTICLES().then((resp) => {
      // console.log(resp);
      this.Articles = resp.data.Articles;
      this.ArticleTypes = resp.data.ArticleTypes;
      // console.log(this.Articles);
    });
  },
};
</script>
